import { render } from "./color-list.vue?vue&type=template&id=62594d3d&ts=true"
import script from "./color-list.vue?vue&type=script&lang=ts"
export * from "./color-list.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__